import { createComponent } from '@helpers/admin';
import AnchorLinksSectionComponent from '@template/blocks/AnchorLinksSection/component';

export const AnchorLinks = createComponent({
  label: 'Link Grid',
  component: AnchorLinksSectionComponent,
  fields: {
    title: {
      label: 'Title',
      type: 'text',
    },
    links: {
      label: 'Links',
      type: 'array',
      arrayFields: {
        label: {
          label: 'Label',
          type: 'text',
        },
        href: {
          label: 'Link',
          type: 'text',
        },
      },
    },
  },
});
